import ErrorIcon from '@cp/src/assets/images/icons/ErrorIcon';
import { RootState } from '@cp/src/store';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';

const FailedFooter = () => {
  const failureReason = useSelector(
    (state: RootState) => state.allocations?.summaryData?.failureMeta?.reason
  );

  return (
    <div className="w-full bg-[var(--navi-color-red-bg)] h-9 flex items-center justify-between">
      <div className="flex items-center gap- mx-6">
        <Typography variant="h4" color="var(--navi-color-gray-c2)">
          Status :
        </Typography>

        <ErrorIcon fill={'var(--navi-color-red-base)'} />

        <Typography variant="h4" color="var(--navi-color-red-base)">
          FAILED : {failureReason}
        </Typography>
      </div>
    </div>
  );
};

export default FailedFooter;
